import * as React from 'react';
import { Component } from 'react';
import { SearchService } from '../../services/SearchService';
import { IDiseaseCategory } from '../../models/IDiseaseCategory';
import { ITherapy } from '../../models/ITherapy';
import { ISearchSelectedItem } from '../../models/ISearchSelectedItem';


interface IProps {
    OnItemClick: (item: ISearchSelectedItem) => void
}

interface IState {
    DiseasesList: IDiseaseCategory[],
    TherapiesList: ITherapy[]
}

export default class FooterComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            DiseasesList: [],
            TherapiesList: []
        }

        this.OnGetAllCategoriesSuccess = this.OnGetAllCategoriesSuccess.bind(this);
        this.OnGetAllCategoriesError = this.OnGetAllCategoriesError.bind(this);

        let service = new SearchService();
        service.GetAllCategoriesFooter(this.OnGetAllCategoriesSuccess, this.OnGetAllCategoriesError);
    }

    public render() {
        let diseaseCategoriesFirstColumn: JSX.Element[] = [];
        let diseaseCategoriesSecondColumn: JSX.Element[] = [];
        let therapiesFirstColumn: JSX.Element[] = [];
        let therapiesSecondColumn: JSX.Element[] = [];

        for (let i = 0; (i < this.state.DiseasesList.length && i < 4); i++) {
            diseaseCategoriesFirstColumn.push(
                (<a key={'f_d_' + this.state.DiseasesList[i].Id} onClick={this.OnDiseaseCategoryClick.bind(this, this.state.DiseasesList[i])}>{this.state.DiseasesList[i].Name}</a>)
            );
        }
        for (let i = 4; (i < this.state.DiseasesList.length && i < 8); i++) {
            diseaseCategoriesSecondColumn.push(
                (<a key={'f_d_' + this.state.DiseasesList[i].Id} onClick={this.OnDiseaseCategoryClick.bind(this, this.state.DiseasesList[i])}>{this.state.DiseasesList[i].Name}</a>)
            );
        }
        for (let i = 0; (i < this.state.TherapiesList.length && i < 4); i++) {
            therapiesFirstColumn.push(
                (<a key={'f_t_' + this.state.TherapiesList[i].Id} onClick={this.OnTherapyClick.bind(this, this.state.TherapiesList[i])}>{this.state.TherapiesList[i].Name}</a>)
            );
        }
        for (let i = 4; (i < this.state.TherapiesList.length && i < 8); i++) {
            therapiesSecondColumn.push(
                (<a key={'f_t_' + this.state.TherapiesList[i].Id} onClick={this.OnTherapyClick.bind(this, this.state.TherapiesList[i])}>{this.state.TherapiesList[i].Name}</a>)
            );
        }

        return (
            <div className="footer-component">
                <div className="popular">
                    <div className="section-left">
                        <h3>Najczęściej wyszukiwane schorzenia</h3>
                        <div className="columns">
                            <div className="column">
                                {diseaseCategoriesFirstColumn}
                            </div>
                            <div className="column">
                                {diseaseCategoriesSecondColumn}
                            </div>
                        </div>
                    </div>
                    <div className="section-right">
                        <h3>Najczęściej wyszukiwane terapie</h3>
                        <div className="columns">
                            <div className="column">
                                {therapiesFirstColumn}
                            </div>
                            <div className="column">
                                {therapiesSecondColumn}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }//end-of-render

    private OnDiseaseCategoryClick(category: IDiseaseCategory, evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.props.OnItemClick({
            Id: category.Id,
            Name: category.Name,
            Type: 'DiseaseCategory'
        });
    }

    private OnTherapyClick(therapy: ITherapy, evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.props.OnItemClick({
            Id: therapy.Id,
            Name: therapy.Name,
            Type: 'Therapy'
        });
    }

    private OnGetAllCategoriesSuccess(result) {
        this.setState({
            DiseasesList: result.data.Value.DiseaseCategories,
            TherapiesList: result.data.Value.Therapies
        });
    }

    private OnGetAllCategoriesError(error) {
        console.log(error);
    }
}


// WEBPACK FOOTER //
// ./src/components/Layout/Footer.tsx